import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const ListItem = ({
  children,
  name,
  link,
  image,
  callToActionText,
  showArrow,
  showBackArrow,
  onClick,
  className,
  isExternal,
  linkAttributes,
}) => (
  <S.ListItem
    onClick={onClick}
    className={className}
    to={link}
    isExternal={isExternal}
    {...(linkAttributes || {})}
  >
    {showBackArrow && <S.LeftArrow />}
    {image && <S.Image>{image}</S.Image>}
    {children}
    <S.Name>{name}</S.Name>
    {callToActionText && <S.CallToAction>{callToActionText}</S.CallToAction>}
    {showArrow && <S.RightArrow />}
  </S.ListItem>
);

const { string, bool, func, node, shape } = PropTypes;

ListItem.propTypes = {
  link: string,
  name: string.isRequired,
  image: node,
  callToActionText: string,
  showArrow: bool,
  showBackArrow: bool,
  onClick: func,
  className: string,
  children: node,
  isExternal: bool,
  linkAttributes: shape({
    target: string,
    rel: string,
  }),
};

ListItem.defaultProps = {
  link: undefined,
  image: null,
  callToActionText: undefined,
  showArrow: false,
  showBackArrow: false,
  onClick: () => {},
  className: undefined,
  children: null,
  isExternal: false,
  linkAttributes: undefined,
};

export default ListItem;
